import { render, staticRenderFns } from "./UiComponentForm.vue?vue&type=template&id=8d7c928a&scoped=true"
import script from "./UiComponentForm.vue?vue&type=script&lang=ts"
export * from "./UiComponentForm.vue?vue&type=script&lang=ts"
import style0 from "./UiComponentForm.vue?vue&type=style&index=0&id=8d7c928a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7c928a",
  null
  
)

export default component.exports